import React from 'react';
import styled from 'styled-components';
import tinycolor from 'tinycolor2';
import { AnchorButton } from 'src/components/core/button';
import { PhoneIcon } from 'src/assets/phone-icon';
import { KIOSK_PRO_MEDIA } from '../../kiosk-pro-shared/kiosk-pro-shared.styles';

export function PhoneNumberLogin({
  phoneLoginUrl,
  hideIcon,
  className,
}: {
  phoneLoginUrl: string;
  hideIcon?: boolean;
  className?: string;
}): JSX.Element {
  return (
    <div className={className}>
      {!hideIcon && (
        <IconContainer>
          <ThemedPhoneIcon />
        </IconContainer>
      )}
      <PhoneButton href={phoneLoginUrl}>Enter phone #</PhoneButton>
    </div>
  );
}

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 220px;
  background-color: ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).toString()};
  border-radius: 50%;
  margin: 0 auto;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 156px;
    height: 156px;
  }
`;

const ThemedPhoneIcon = styled(PhoneIcon)`
  color: ${({ theme }) => theme.customized.colors.buttonsLinks};

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 80px;
    height: 80px;
  }
`;

const PhoneButton = styled(AnchorButton)`
  display: inline-block;
  margin: 36px 0 0 0;
  padding: 24px;
  line-height: 15px;
  font-weight: 700;
  font-size: clamp(20px, 3vw, 24px);

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 20px;
    padding: 20px 28px;
  }
`;
